/*eslint-disable no-mixed-operators */
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  GetEncryptionKey,
  GetKeyStoreResources,
  GetBranding,
  GetContactInfo,
  GetFooterLinks,
  GetMediaLinks,
  GetLogoImage,
} from './api/themesCalls';
import CommonErrorHandler from './Components/CommonErrorHandler';
import { USER_TYPES } from './constants';
import { PageNotFoundSVG } from './Member/img/ServerErrorSVG';

export default function StartUp() {
  const dispatch = useDispatch();
  const { isEncryptionSet, isStoreKeySet, isEncryptionKeyFailed } = useSelector(
    (state) => state.key,
  );
  const { isThemeLoaded, branding, isLogoLoaded } = useSelector(
    (state) => state.theme,
  );
  const { isContantInfoLoaded, isLinksLoaded, isMediaLinksLoaded } =
    useSelector((state) => state.footer);
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const location = useLocation();
  useEffect(() => {
    if (
      !isEncryptionSet ||
      !isThemeLoaded ||
      !isContantInfoLoaded ||
      !isMediaLinksLoaded ||
      !isLogoLoaded
    ) {
      dispatch(GetEncryptionKey());
    }

    if (isEncryptionSet && !isStoreKeySet) {
      dispatch(GetKeyStoreResources());
    }

    if (isEncryptionSet && isStoreKeySet) {
      if (!isThemeLoaded) {
        dispatch(GetBranding());
      }
      if (!isLogoLoaded && isThemeLoaded) {
        dispatch(GetLogoImage(branding.LogoOID));
      }
      if (!isMediaLinksLoaded) {
        dispatch(GetMediaLinks());
      }
    }

    if (
      !location.pathname.includes('/admin') &&
      (!isLoggedIn ||
        (userData && userData?.UserType === USER_TYPES.DEPENDENT) ||
        userData?.UserType === USER_TYPES.EMPLOYEE)
    ) {
      //document.title = branding?.ClientName
      //? `${branding?.ClientName} Member Portal`
      //: 'Member Portal';
      if (isEncryptionSet && isStoreKeySet) {
        //if ( !isThemeLoaded ) {
        //dispatch( GetBranding() );
        //}
        if (!isContantInfoLoaded) {
          dispatch(GetContactInfo());
        }
        if (!isLinksLoaded) {
          dispatch(GetFooterLinks());
        }
        //if ( !isMediaLinksLoaded ) {
        //dispatch( GetMediaLinks() );
        //}
        if (!isLogoLoaded && isThemeLoaded) {
          dispatch(GetLogoImage(branding.LogoOID));
        }
      }
    } else {
      //document.title = branding?.ClientName
      //? `${branding?.ClientName} Admin Center`
      //: 'Admin Center';
    }
  }, [isEncryptionSet, isStoreKeySet, isThemeLoaded, isLinksLoaded]);

  useEffect(() => {
    if (!isLoggedIn) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [isLoggedIn]);

  return (
    <>
      {isEncryptionKeyFailed && location.pathname === '/member' && (
        <>
          <Container className="page-not-found">
            <Row>
              <Col className="text-center no-data-found-component">
                <div className="page-not-found-container">
                  <PageNotFoundSVG />
                  <div className="content-box">
                    <h1>Server is Down</h1>
                    <p>Currently server is down please try after sometime</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
  //return <CommonErrorHandler />;
}
